export function convertUTCToLocalDate(date) {
  if (!date) {
    return date;
  }
  date = new Date(date);
  date = new Date(date.getTime() + date.getTimezoneOffset() * 60000).toJSON();
  return date;
}

export function convertLocalToUTCDate(date) {
  if (!date) {
    return date;
  }
  date = new Date(date);
  date = new Date(
    Date.UTC(
      date.getFullYear(),
      date.getMonth(),
      date.getDate(),
      date.getHours(),
      date.getMinutes()
    )
  );
  return date;
}

export const fixTimezoneOffset = (date, isUTC = false) => {
  if (!date) return "";
  date = new Date(date);
  if (date < new Date(null)) date = new Date(null);
  if (isUTC) {
    return {
      utc: new Date(date.getTime()).toJSON(),
      date: new Date(date.getTime() + date.getTimezoneOffset() * 60000),
    };
  } else {
    return {
      utc: new Date(date.getTime() - date.getTimezoneOffset() * 60000).toJSON(),
      date,
    };
  }
};
